<template>
  <div class="grid-operations">
    <template v-for="(operation,i) in operations">
      <span v-if="getDisabled(operation) && operation.visible(params.data)" :key="i" style="padding: 5px">{{ operation.title }}</span>
      <a v-else-if="operation.visible(params.data)" :key="i" :style="operation.cssStyle" :class="`grid-operations-${operation.type}`" @click="()=>operation.onClick(params.data)">{{ operation.title }}</a>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import ColumnUtils from '@/utils/ColumnUtils'
import { INSTRUCTION_ACTION_SINGLE, INSTRUCTION_ACTION_BATCH } from '@/class/cargo/model/parameters/SystemConstants'
export default Vue.extend({
  name: 'InstructionBtns',
  data() {
    return {
      operations: []
    }
  },
  created() {
    const instructionOperations = []
    if (this.params.tenantInstructions && this.params.tenantInstructions.length > 0 &&
      this.params.data.instructionUuids && this.params.data.instructionUuids.length > 0) {
      this.params.tenantInstructions.forEach(tenantInstruction => {
        if (this.params.data.instructionUuids.indexOf(tenantInstruction.uuid) > -1) {
          instructionOperations.push({
            title: ColumnUtils.instructionNameLabelFunc(tenantInstruction),
            type: 'primary',
            cssStyle: 'text-decoration: underline;',
            onClick: (p) => {
              // 获取表格选中的行
              const selectedRows = this.params.gridApi ? this.params.gridApi.getSelectedRows() : []
              let jobs = []
              let action = INSTRUCTION_ACTION_SINGLE.code

              if (selectedRows.length > 1) {
                // 多选情况：使用批量操作，传递选中的行但表单显示空数据
                jobs = selectedRows
                action = INSTRUCTION_ACTION_BATCH.code
              } else if (selectedRows.length === 1) {
                // 单选情况：使用单条操作，显示选中行的数据
                jobs = selectedRows
                action = INSTRUCTION_ACTION_SINGLE.code
              } else {
                // 没有选中任何行：使用当前行数据
                jobs = [this.params.data]
                action = INSTRUCTION_ACTION_SINGLE.code
              }

              this.params.instructionClick(tenantInstruction, jobs, action)
            },
            visible: (p) => true
          })
        }
      })
    }
    this.operations = instructionOperations
  },
  methods: {
    getDisabled(operation) {
      if (typeof operation.disabled === 'function') {
        return operation.disabled(this.params.data)
      }
      return operation.disabled
    }
  }
})
</script>

<style scoped lang="scss">
@import "src/styles/element-variables";
.grid-operations{
  a {
    padding: 5px;
  }
  &-primary {
    color: $--color-primary;
  }
  &-success {
    color: $--color-success;
  }
  &-warning {
    color: $--color-warning;
  }
  &-danger {
    color: $--color-danger;
  }
}
</style>
